// Category taxonomy grouped for display — matches the Experiences design
// spec (docs/superpowers/specs/2026-07-29-experiences-vertical-design.md
// §1 / the Task 4 brief): "Tours" = the sightseeing-style listings,
// "Activities" = the active/equipment ones. Must stay aligned with the
// 15-value Tour#category enum (app/models/tour.rb) — every value should
// appear in exactly one of these two groups.
//
// Single source of truth (fix-wave 2026-07-30, M-3): this used to be
// duplicated verbatim in Pages/Public/Tours/Index.vue and
// Pages/VendorPortal/Tours/Form.vue. VendorPortal/Tours/Form.vue FILTERS its
// category <select> through these arrays, so a future enum value added here
// only would silently become un-pickable in the vendor form — keep both
// groups exhaustive whenever the enum changes.
export const TOUR_CATEGORY_GROUP = [
  'boat_trip', 'snorkel', 'island_hopping', 'cultural', 'city', 'historic', 'eco',
]

export const ACTIVITY_CATEGORY_GROUP = [
  'adventure', 'diving', 'surfing', 'watersports', 'atv_offroad', 'e_mobility', 'classes', 'other',
]
